import React, { useState } from "react";
import { Modal, Button, UncontrolledTooltip, Input } from "reactstrap";
import _ from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";

const FormRow = ({ title, children }) => (
  <div style={{ display: "flex", width: "100%", fontSize: 12 }}>
    <p style={{ fontWeight: "bold", width: 100, fontSize: 12 }}>{title}</p>
    <p style={{ marginLeft: 5, marginRight: 10, fontSize: 12 }}>:</p>
    <p style={{ flex: 1, fontSize: 12 }}>{children}</p>
  </div>
);

function AttackView({ attack, onClose }) {
  const [str, setStr] = useState("");
  const [isWhitelist, setWhitelist] = useState(false);
  const [isExclude, setIsExclude] = useState(false);
  const [type, setType] = useState("customer");

  const history = useHistory();

  const handleExclude = (mode) => {
    const requestData = {};
    requestData[mode] = str;
    if (type === "customer") {
      history.push({
        pathname: `/customers/customer_settings/${_.get(
          attack,
          "Device.License.CustomerId"
        )}`,
        state: requestData,
      });
    }
    if (type === "endpoint") {
      history.push({
        pathname: `/endpoints/endpoint_settings/${_.get(
          attack,
          "Device.DeviceId"
        )}`,
        state: requestData,
      });
    }
  };

  const prepareFolderPath = (val) => {
    try {
      const splitVal = val.split("\\");
      splitVal.pop();
      setStr(splitVal.join("\\") + "\\");
    } catch (error) {
      console.log("error fetching process path", error);
    }
  };

  return (
    <div>
      <Modal isOpen={attack} toggle={() => onClose()}>
        <div className="modal-header" style={{ fontWeight: "bold" }}>
          Alert Details
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              onClose();
            }}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ paddingTop: 0 }}>
          <FormRow title="Time">
            {attack
              ? moment(
                  _.get(attack, "Attack.Time") +
                    (_.get(attack, "Attack.Time")[
                      _.get(attack, "Attack.Time").length - 1
                    ] === "Z"
                      ? ""
                      : "Z")
                ).format("YYYY-MM-DD, h:mm:ss a")
              : ""}
          </FormRow>
          <FormRow title="Process">
            <div
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "200px",
              }}
            >
              {_.get(attack, "Attack.ProcessName")}
            </div>
          </FormRow>
          <FormRow title="Process Id">
            {_.get(attack, "Attack.ProcessId")}
          </FormRow>
          <FormRow title="Last File Name">
            {_.get(attack, "Attack.LastFileName")}
          </FormRow>
          <FormRow title="Device">
            <a
              href={`/#/endpoints/endpoint_details/${_.get(
                attack,
                "Device.DeviceId"
              )}`}
              target="_blank"
            >
              {_.get(attack, "Device.Hostname")}
            </a>
          </FormRow>
          <FormRow title="Ip Address">
            {_.get(attack, "Attack.IpAddress")}
          </FormRow>
          <FormRow title="User">{_.get(attack, "Attack.User")}</FormRow>
          {/* <FormRow title="Customer">
            {_.get(attack, "Customer.CompanyName")}
          </FormRow> */}
          <FormRow title="Learning Mode">
            {_.get(attack, "Attack.LearningModeStatus") ? (
              <span style={{ color: "#1E8DCC" }}>ON</span>
            ) : (
              <span style={{ color: "#e4535a" }}>OFF</span>
            )}
          </FormRow>
          <FormRow title="Suppress Email">
            {_.get(attack, "Attack.SupressEmail") ? (
              <span style={{ color: "#1E8DCC" }}>ON</span>
            ) : (
              <span style={{ color: "#e4535a" }}>OFF</span>
            )}
          </FormRow>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              id="viewCustomer"
              size="sm"
              outline
              color="primary"
              onClick={() =>
                window.open(
                  `/#/customers/customer_details/${_.get(
                    attack,
                    "Device.License.CustomerId"
                  )}`
                )
              }
            >
              <i class="fa fa-users" aria-hidden="true" />
              <UncontrolledTooltip target="viewCustomer" autohide={false}>
                View Customer
              </UncontrolledTooltip>
            </Button>
            <Button
              id="whitelistProcess"
              size="sm"
              outline
              color="primary"
              onClick={() => {
                setWhitelist(true);
                setStr(_.get(attack, "Attack.ProcessName") || "");
              }}
            >
              <i class="fa fa-tasks" aria-hidden="true" />
              <UncontrolledTooltip target="whitelistProcess" autohide={false}>
                Whitelist Process
              </UncontrolledTooltip>
            </Button>
            <Button
              id="excludeFolder"
              size="sm"
              outline
              color="primary"
              onClick={() => {
                setIsExclude(true);
                prepareFolderPath(_.get(attack, "Attack.LastFileName") || "");
              }}
            >
              <i class="fa fa-folder-open" aria-hidden="true" />
              <UncontrolledTooltip target="excludeFolder" autohide={false}>
                Exclude Folder
              </UncontrolledTooltip>
            </Button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isExclude} toggle={() => setIsExclude(false)}>
        <div className="modal-header" style={{ fontWeight: "bold" }}>
          Exclude Folder
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setIsExclude(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <FormRow title="Path">
            <Input
              value={str}
              bsSize="sm"
              onChange={(e) => setStr(e.target.value)}
            />
          </FormRow>
          <FormRow title="Type">
            <Input
              id="exampleSelect"
              name="select"
              value={type}
              type="select"
              style={{
                width: 200,
                overflowY: "auto",
                overflowX: "hidden",
                minWidth: "100%",
              }}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="customer">Customer</option>
              <option value="endpoint">Endpoint</option>
            </Input>
          </FormRow>
        </div>
        <div className="modal-footer" style={{ paddingTop: 0 }}>
          <Button
            color="primary"
            onClick={() => handleExclude("FolderExclusion")}
          >
            Continue
          </Button>
          <Button
            color="danger"
            outline
            onClick={() => {
              setStr("");
              setIsExclude(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <Modal isOpen={isWhitelist} toggle={() => setWhitelist(false)}>
        <div className="modal-header" style={{ fontWeight: "bold" }}>
          Whitelist Process
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setWhitelist(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <FormRow title="Process">
            <Input
              value={str}
              bsSize="sm"
              onChange={(e) => setStr(e.target.value)}
            />
          </FormRow>
          <FormRow title="Type">
            <Input
              id="exampleSelect"
              name="select"
              value={type}
              type="select"
              style={{
                width: 200,
                overflowY: "auto",
                overflowX: "hidden",
                minWidth: "100%",
              }}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="customer">Customer</option>
              <option value="endpoint">Endpoint</option>
            </Input>
          </FormRow>
        </div>
        <div className="modal-footer" style={{ paddingTop: 0 }}>
          <Button color="primary" onClick={() => handleExclude("WhiteList")}>
            Continue
          </Button>
          <Button
            color="danger"
            outline
            onClick={() => {
              setStr("");
              setWhitelist(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default AttackView;
